var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14, _path16, _g15, _path17, _g16, _path18, _g17, _path19, _g18, _path20, _g19, _path21, _g20, _path22, _g21, _path23, _g22, _path24, _g23, _path25, _g24, _path26, _g25, _path27, _g26, _path28, _g27, _path29, _g28, _path30, _g29, _path31, _g30, _path32, _g31, _path33, _g32, _path34, _g33, _path35, _g34, _path36, _g35, _path37, _g36, _path38, _g37, _path39, _g38, _path40, _g39, _path41, _g40, _path42, _g41, _path43, _g42, _path44, _g43, _path45, _g44, _path46, _g45, _path47, _g46, _path48, _g47, _path49, _g48, _path50, _g49, _path51, _g50, _path52, _g51, _path53, _g52, _path54, _g53, _path55, _g54, _path56, _g55, _path57, _g56, _path58, _g57, _path59, _g58, _path60, _g59, _path61, _g60, _path62, _g61, _path63, _g62, _path64, _g63, _path65, _g64, _path66, _g65, _path67, _g66, _path68, _g67, _path69, _g68, _path70, _g69, _path71, _g70, _path72, _g71, _path73, _g72, _path74, _g73, _path75, _g74, _path76, _g75, _path77, _g76, _path78, _g77, _path79, _g78, _path80, _g79, _path81, _g80, _path82, _g81, _path83, _g82, _path84, _g83, _path85, _g84, _path86, _g85, _path87, _g86, _path88, _g87, _path89, _g88, _path90, _g89, _path91, _g90, _path92, _g91, _path93, _g92, _path94, _g93, _path95, _g94, _path96, _g95, _path97, _g96, _path98, _g97, _path99, _g98, _path100, _path101, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 301,
    viewBox: "0 0 301 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_516_13702)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_516_13702)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.462 -0.26001C67.2645 -0.26001 -0.155273 67.198 -0.155273 150.44C-0.155273 233.653 67.2645 301.139 150.462 301.139C233.63 301.139 301.078 233.653 301.078 150.44C301.078 67.198 233.63 -0.26001 150.462 -0.26001ZM150.462 265.798C86.7955 265.798 35.166 214.154 35.166 150.44C35.166 86.739 86.7955 35.081 150.462 35.081C214.127 35.081 265.729 86.725 265.729 150.44C265.729 214.14 214.127 265.798 150.462 265.798Z",
    fill: "#152656"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79785 141.328L8.96595 140.094L18.5914 132.65L10.3111 131.487L10.8855 127.449L27.194 129.734L27.026 130.94L17.3725 138.426L25.6669 139.575L25.1064 143.613L8.79785 141.328Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0263 127.645L26.9987 129.874L26.8726 130.786L17.5834 138.033L16.9249 138.538L17.7375 138.65L25.4435 139.729L24.9251 143.416L8.96674 141.187L9.09284 140.262L18.34 133.043L18.9985 132.538L18.1859 132.426L10.4939 131.346L11.0263 127.645ZM10.7321 127.253L10.1156 131.641L18.1578 132.762L8.79864 140.066L8.60254 141.482L25.2613 143.809L25.8778 139.435L17.8216 138.314L27.2088 130.982L27.405 129.594L10.7321 127.253Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4922 116.248L14.0106 114.454L31.9585 111.664L30.7396 115.954L28.6379 116.234L26.8726 122.431L28.5119 123.776L27.2929 128.052L13.4922 116.248ZM20.5957 117.286L24.4347 120.44L25.5135 116.641L20.5957 117.286Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7061 111.875L30.5992 115.786L28.7358 116.024L28.5116 116.052L28.4556 116.276L26.7603 122.262L26.7042 122.487L26.8864 122.627L28.3435 123.832L27.2366 127.73L13.7302 116.178L14.1785 114.594L31.7061 111.875ZM24.5325 120.748L24.6726 120.23L25.6114 116.935L25.7515 116.417L25.2191 116.487L20.9598 117.047L20.1612 117.16L20.7917 117.678L24.1122 120.412L24.5325 120.748ZM32.1965 111.454L13.8703 114.3L13.2959 116.319L27.3907 128.374L28.7078 123.72L27.0685 122.375L28.7638 116.389L30.8514 116.108L32.1965 111.454ZM25.2751 116.851L24.3364 120.146L21.0158 117.412L25.2751 116.851Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5057 104.529L20.0206 108.244L16.5039 106.828L21.0013 95.613L24.518 97.029L23.0329 100.73L34.6759 105.398L33.1487 109.197L21.5057 104.529Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1001 95.8372L24.2945 97.1132L22.9355 100.491L22.8094 100.814L23.1316 100.94L34.4384 105.482L33.0513 108.959L21.7445 104.417L21.4223 104.29L21.2962 104.613L19.9372 108.005L16.7427 106.73L21.1001 95.8372ZM20.9039 95.3892L16.2803 106.94L20.1193 108.482L21.6044 104.767L33.2474 109.435L34.9007 105.314L23.2577 100.632L24.7429 96.9312L20.9039 95.3892Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -274,
    y: -1621,
    width: 2181,
    height: 2332
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M552.423 -1620.16L-273.615 33.5939L1080.12 710.693L1906.16 -943.061L552.423 -1620.16Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3483 89.1079L22.5322 92.7439L37.1083 100.034L38.9244 96.3989L24.3483 89.1079Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4343 89.333L38.6974 96.468L37.0301 99.791L22.767 92.655L24.4343 89.333ZM24.2802 88.856L22.3047 92.809L37.1842 100.253L39.1597 96.3L24.2802 88.856Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.366 91.295C35.7688 91.295 34.1996 90.819 32.8125 89.936C30.8089 88.66 29.4639 86.711 29.0156 84.44C28.5672 82.183 29.0436 79.786 30.3746 77.711C32.0979 75.02 34.9001 73.408 37.8704 73.408C39.4816 73.408 41.0789 73.884 42.48 74.782C44.4695 76.043 45.8005 77.992 46.2349 80.249C46.6692 82.506 46.1928 84.903 44.8618 86.978C43.1385 89.683 40.3363 91.295 37.366 91.295ZM37.6883 77.487C36.063 77.487 34.5498 78.342 33.6251 79.786C32.9106 80.908 32.6584 82.197 32.9106 83.431C33.1628 84.665 33.9053 85.73 34.9982 86.431C35.7688 86.922 36.6374 87.188 37.5341 87.188C39.1594 87.188 40.6726 86.319 41.5833 84.889C42.2978 83.767 42.55 82.478 42.2978 81.244C42.0456 80.01 41.303 78.945 40.2242 78.258C39.4536 77.753 38.5709 77.487 37.6883 77.487Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8709 73.59C39.4401 73.59 41.0093 74.053 42.3823 74.936C44.3299 76.183 45.6329 78.076 46.0672 80.291C46.5015 82.506 46.0111 84.847 44.7081 86.894C43.0128 89.543 40.2807 91.127 37.3665 91.127C35.8113 91.127 34.2561 90.665 32.897 89.795C30.9355 88.548 29.6185 86.641 29.1701 84.412C28.7218 82.197 29.1982 79.842 30.5012 77.81C32.2105 75.16 34.9566 73.59 37.8709 73.59ZM37.5346 87.356C39.2159 87.356 40.7851 86.459 41.7379 84.973C42.4804 83.809 42.7326 82.478 42.4804 81.202C42.2142 79.926 41.4436 78.819 40.3228 78.104C39.5241 77.585 38.5994 77.319 37.6747 77.319C35.9934 77.319 34.4242 78.202 33.4715 79.702C31.9583 82.085 32.5888 85.099 34.9006 86.585C35.7132 87.09 36.6239 87.356 37.5346 87.356ZM37.8709 73.24C34.9146 73.24 32.0283 74.782 30.221 77.627C27.4328 82.001 28.4976 87.398 32.7149 90.09C34.186 91.029 35.7832 91.478 37.3665 91.478C40.3087 91.478 43.195 89.936 45.0024 87.09C47.8045 82.716 46.7537 77.319 42.5645 74.655C41.0933 73.688 39.4681 73.24 37.8709 73.24ZM37.5346 87.006C36.708 87.006 35.8673 86.767 35.0967 86.277C32.925 84.889 32.3366 82.113 33.7657 79.87C34.6904 78.426 36.1615 77.655 37.6747 77.655C38.5154 77.655 39.356 77.894 40.1266 78.384C42.2843 79.772 42.8587 82.534 41.4436 84.777C40.5329 86.235 39.0478 87.006 37.5346 87.006Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.123 66.9169L38.9356 65.9639L51.0832 64.8979L44.7361 59.4449L47.3982 56.3469L59.9102 67.1129L59.1112 68.0529L46.9358 69.118L53.2832 74.5849L50.6342 77.683L38.123 66.9169Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4117 56.6L59.6717 67.142L59.0687 67.828L47.3277 68.908L46.501 68.978L47.1315 69.525L53.0437 74.613L50.6207 77.445L38.3747 66.917L38.9772 66.202L50.6767 65.137L51.5027 65.067L50.8727 64.52L44.9738 59.445L47.4117 56.6ZM47.3837 56.095L44.4975 59.459L50.6627 64.758L38.8231 65.838L37.8984 66.917L50.6767 77.908L53.5627 74.543L47.3837 69.23L59.2787 68.137L60.2037 67.071L47.3837 56.095Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5801 48.385L56.9811 47.137L73.6121 54.469L70.2781 57.427L68.3581 56.529L63.5381 60.805L64.1971 62.824L60.8621 65.782L55.5801 48.385ZM62.5581 57.819L65.5141 55.198L61.0171 53.095L62.5581 57.819Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0098 47.347L73.2898 54.525L70.2498 57.23L68.5398 56.431L68.3298 56.333L68.1618 56.487L63.5108 60.623L63.3418 60.777L63.4118 60.987L64.0008 62.782L60.9608 65.473L55.7908 48.455L57.0098 47.347ZM62.4738 58.128L62.8798 57.777L65.4438 55.506L65.8498 55.156L65.3598 54.931L61.4648 53.109L60.7358 52.772L60.9888 53.543L62.3198 57.637L62.4738 58.128ZM56.9528 46.927L55.3838 48.315L60.7778 66.076L64.3928 62.866L63.7348 60.847L68.3858 56.726L70.3058 57.623L73.9348 54.413L56.9528 46.927ZM62.6418 57.511L61.3108 53.417L65.2058 55.24L62.6418 57.511Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7803 40.17L69.1293 37.843L76.2743 48.132L81.5143 44.488L83.6863 47.614L75.0973 53.586L65.7803 40.17Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.087 38.0811L76.022 48.0901L76.218 48.3851L76.512 48.1891L81.472 44.7401L83.448 47.5861L75.139 53.3611L66.032 40.2261L69.087 38.0811ZM69.185 37.5911L65.542 40.1141L75.055 53.8241L83.938 47.6561L81.57 44.2351L76.33 47.8801L69.185 37.5911Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5596 28.899L92.9326 24.301L94.6006 27.679L88.8276 30.497L90.0046 32.908L94.7546 30.581L96.2256 33.581L91.4756 35.908L92.6806 38.362L98.4396 35.53L100.107 38.936L90.7336 43.534L83.5596 28.899Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.8633 24.525L94.3623 27.595L88.9123 30.273L88.6043 30.427L88.7583 30.735L89.7813 32.824L89.9353 33.147L90.2433 32.992L94.6713 30.819L95.9883 33.497L91.5603 35.67L91.2523 35.824L91.4063 36.146L92.4573 38.291L92.6113 38.6L92.9193 38.446L98.3693 35.768L99.8833 38.852L90.8183 43.296L83.7983 28.969L92.8633 24.525ZM93.0173 24.062L83.3223 28.815L90.6493 43.773L100.345 39.02L98.5243 35.305L92.7513 38.137L91.7003 35.992L96.4503 33.665L94.8253 30.357L90.0753 32.684L89.0523 30.595L94.8253 27.763L93.0173 24.062Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.7441 22.7031L100.555 21.2871L104.898 32.9921L110.867 30.7771L112.184 34.3381L102.405 37.9691L96.7441 22.7031Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.443 21.511L104.66 32.894L104.786 33.217L105.109 33.09L110.755 31.002L111.96 34.24L102.502 37.759L96.9539 22.815L100.443 21.511ZM100.653 21.062L96.5059 22.605L102.292 38.207L112.408 34.45L110.965 30.553L104.996 32.768L100.653 21.062Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.858 18.021L119.974 15.385L120.927 19.03L114.706 20.656L115.379 23.25L120.493 21.904L121.333 25.142L116.219 26.474L116.906 29.123L123.127 27.511L124.079 31.184L113.964 33.82L109.858 18.021Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.848 15.595L120.703 18.9041L114.818 20.4321L114.482 20.5161L114.566 20.8521L115.154 23.109L115.239 23.446L115.575 23.362L120.352 22.114L121.109 25.0161L116.331 26.263L115.995 26.3481L116.079 26.6841L116.682 28.997L116.766 29.334L117.102 29.249L122.986 27.721L123.855 31.058L114.076 33.595L110.054 18.133L119.848 15.595ZM120.1 15.175L109.648 17.894L113.837 34.03L124.29 31.31L123.253 27.301L117.032 28.927L116.429 26.614L121.557 25.282L120.633 21.707L115.505 23.039L114.916 20.782L121.137 19.17L120.1 15.175Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.326 29.964C129.501 29.964 125.298 27.455 124.626 22.675C124.303 20.362 124.92 18.091 126.349 16.296C127.778 14.488 129.908 13.31 132.346 12.974C132.668 12.932 132.99 12.918 133.326 12.918C135.106 12.918 136.997 13.493 138.538 14.502L136.647 17.782C135.666 17.152 134.517 16.801 133.48 16.801C133.284 16.801 133.088 16.815 132.906 16.843C131.617 17.025 130.482 17.67 129.698 18.652C128.899 19.647 128.549 20.895 128.731 22.156C129.053 24.427 131.085 26.151 133.466 26.151C133.677 26.151 133.901 26.137 134.111 26.109C135.358 25.941 136.521 25.254 137.558 24.077L140.276 26.81C139.225 28.044 137.403 29.53 134.657 29.922C134.195 29.936 133.761 29.964 133.326 29.964Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.327 13.0719C135.022 13.0719 136.815 13.6049 138.3 14.5439L136.577 17.5159C135.596 16.9269 134.489 16.6049 133.481 16.6049C133.271 16.6049 133.074 16.6189 132.878 16.6469C131.547 16.8289 130.37 17.5019 129.558 18.5109C128.731 19.5489 128.367 20.8379 128.549 22.1419C128.885 24.5109 130.987 26.2919 133.453 26.2919C133.677 26.2919 133.901 26.2779 134.125 26.2499C135.358 26.0809 136.521 25.4219 137.544 24.3009L140.01 26.7819C138.959 27.9599 137.208 29.3339 134.602 29.7119C134.181 29.7679 133.747 29.7959 133.327 29.7959C129.698 29.7959 125.481 27.5669 124.808 22.6469C124.486 20.3899 125.088 18.1609 126.489 16.3949C127.89 14.6279 129.992 13.4649 132.374 13.1279C132.682 13.0859 133.004 13.0719 133.327 13.0719ZM133.327 12.7219C132.99 12.7219 132.654 12.7499 132.318 12.7779C127.19 13.4929 123.757 17.7959 124.444 22.6889C125.102 27.3709 129.109 30.1329 133.313 30.1329C133.761 30.1329 134.195 30.1049 134.644 30.0349C137.152 29.6839 139.113 28.3939 140.486 26.7399L137.53 23.7679C136.605 24.8759 135.456 25.7029 134.069 25.8849C133.859 25.9129 133.649 25.9269 133.439 25.9269C131.295 25.9269 129.207 24.4129 128.885 22.0859C128.535 19.5629 130.37 17.3339 132.92 16.9689C133.102 16.9409 133.285 16.9269 133.481 16.9269C134.56 16.9269 135.736 17.3199 136.703 17.9929L138.763 14.4039C137.166 13.3239 135.19 12.7219 133.327 12.7219Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.082 16.058L141.075 16.156L140.99 12.371L153.054 12.063L153.152 15.848L149.159 15.946L149.481 28.478L145.39 28.591L145.082 16.058Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.886 12.2451L152.97 15.6801L149.327 15.7641L148.977 15.7781L148.991 16.1281L149.299 28.3101L145.558 28.4081L145.264 16.2261L145.25 15.8761L144.899 15.8901L141.243 15.9881L141.158 12.5531L152.886 12.2451ZM153.222 11.8811L140.794 12.1891L140.892 16.3241L144.899 16.2261L145.208 28.7591L149.649 28.6471L149.341 16.1141L153.334 16.0161L153.222 11.8811Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.094 29.1791L160.045 21.1191L159.387 28.7731L155.323 28.4221L156.697 12.1611L162.819 12.6801C166.224 12.9741 168.606 15.4411 168.354 18.4131C168.185 20.3061 166.952 21.9321 165.215 22.5631L165.019 22.6331L168.844 29.5721L164.094 29.1791ZM160.129 19.8011L162.105 19.9831C162.175 19.9971 162.245 19.9971 162.315 19.9971C163.338 19.9971 164.15 19.2821 164.234 18.3151C164.332 17.1091 163.38 16.3801 162.427 16.3101L160.451 16.1421L160.129 19.8011Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.851 12.357L162.805 12.862C166.112 13.142 168.423 15.525 168.171 18.413C168.017 20.235 166.826 21.806 165.145 22.408L164.753 22.548L164.949 22.913L168.508 29.39L164.192 29.025L160.451 21.609L159.891 20.502L159.793 21.735L159.204 28.604L155.491 28.282L156.851 12.357ZM162.315 20.165C163.436 20.165 164.318 19.394 164.402 18.315C164.5 17.165 163.646 16.212 162.427 16.114L160.619 15.96L160.269 15.932L160.241 16.282L159.961 19.619L159.933 19.969L160.283 19.997L162.077 20.165C162.161 20.165 162.231 20.165 162.315 20.165ZM156.528 11.979L155.127 28.59L159.541 28.969L160.157 21.749L163.982 29.347L169.138 29.782L165.257 22.731C166.952 22.128 168.339 20.502 168.522 18.427C168.774 15.455 166.42 12.806 162.833 12.497L156.528 11.979ZM162.315 19.815C162.245 19.815 162.189 19.815 162.119 19.801L160.311 19.633L160.591 16.31L162.385 16.464C163.31 16.549 164.122 17.249 164.038 18.287C163.968 19.24 163.169 19.815 162.315 19.815Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -89,
    y: -1617,
    width: 1811,
    height: 2085
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M231.581 -1616.28L-88.8223 204.438L1401.57 467.313L1721.98 -1353.4L231.581 -1616.28Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.407 13.9629L170.575 30.0459L174.591 30.7539L177.423 14.6709L173.407 13.9629Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.565 14.166L177.236 14.81L174.462 30.553L170.791 29.908L173.565 14.166ZM173.285 13.759L170.385 30.189L174.742 30.96L177.643 14.53L173.285 13.759Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.618 34.016C186.834 34.016 186.035 33.904 185.265 33.693C181.033 32.544 177.503 28.268 178.904 23.123C179.927 19.395 183.261 16.885 187.226 16.885C188.095 16.885 188.963 16.997 189.832 17.236C191.808 17.81 193.699 19.24 194.918 21.077L191.892 23.348C191.107 22.184 189.972 21.301 188.823 20.993C188.389 20.867 187.927 20.81 187.478 20.81C185.293 20.81 183.443 22.184 182.883 24.231C182.547 25.451 182.743 26.74 183.429 27.848C184.074 28.899 185.111 29.67 186.287 29.993C186.68 30.105 187.1 30.161 187.52 30.161C188.389 30.161 189.3 29.936 190.252 29.474L191.668 33.049C190.365 33.693 189.006 34.016 187.618 34.016Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.212 16.7031V17.0531C188.053 17.0531 188.921 17.1651 189.762 17.4041C191.653 17.9511 193.461 19.2961 194.666 21.0351L191.92 23.0951C191.121 21.9741 189.986 21.1331 188.851 20.8241C188.403 20.6981 187.927 20.6421 187.464 20.6421C185.194 20.6421 183.289 22.0721 182.701 24.1891C182.35 25.4641 182.56 26.7961 183.261 27.9321C183.933 29.0111 185.012 29.8241 186.217 30.1471C186.624 30.2591 187.058 30.3151 187.492 30.3151C188.333 30.3151 189.216 30.1051 190.126 29.6981L191.415 32.9501C190.182 33.5251 188.907 33.8201 187.604 33.8201C186.834 33.8201 186.049 33.7071 185.293 33.5111C181.145 32.3761 177.671 28.1981 179.044 23.1511C180.038 19.4931 183.317 17.0391 187.198 17.0391V16.7031M187.212 16.7031C183.233 16.7031 179.786 19.1701 178.721 23.0671C177.348 28.1141 180.683 32.6141 185.208 33.8481C186.035 34.0721 186.834 34.1701 187.604 34.1701C189.145 34.1701 190.589 33.7771 191.864 33.1191L190.308 29.2211C189.398 29.6701 188.431 29.9641 187.478 29.9641C187.086 29.9641 186.68 29.9081 186.287 29.8101C183.99 29.1791 182.336 26.7681 183.023 24.2731C183.583 22.2401 185.419 20.9791 187.436 20.9791C187.87 20.9791 188.305 21.0351 188.739 21.1471C189.93 21.4691 191.079 22.4081 191.808 23.5861L195.114 21.1051C193.881 19.1561 191.906 17.6421 189.832 17.0531C188.963 16.8151 188.081 16.7031 187.212 16.7031Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.422 40.002L203.408 37.885L197.468 35.362L195.927 36.82L191.822 35.081L205.258 22.801L206.981 23.53L207.542 41.726L203.422 40.002ZM199.738 33.189L203.38 34.731L203.338 29.754L199.738 33.189Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.286 23.025L206.813 23.67L207.36 41.488L203.605 39.904L203.591 38.011V37.773L203.381 37.689L197.65 35.263L197.44 35.179L197.272 35.334L195.899 36.637L192.144 35.053L205.286 23.025ZM203.563 34.997V34.464L203.535 30.161L203.521 29.348L202.932 29.908L199.808 32.88L199.416 33.245L199.906 33.455L203.058 34.787L203.563 34.997ZM205.216 22.605L191.5 35.137L195.955 37.03L197.496 35.572L203.227 37.997L203.241 40.114L207.71 42.006L207.136 23.418L205.216 22.605ZM203.199 34.464L200.046 33.133L203.171 30.161L203.199 34.464Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.971 42.7208L217.069 28.5488L220.614 30.5668L214.407 41.4458L219.941 44.6138L218.05 47.9078L208.971 42.7208Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.139 28.7871L220.376 30.6371L214.337 41.2071L214.169 41.5161L214.477 41.6841L219.717 44.6841L218.008 47.6841L209.237 42.6651L217.139 28.7871ZM216.999 28.3101L208.733 42.7911L218.12 48.1601L220.18 44.5581L214.645 41.3891L220.852 30.5251L216.999 28.3101Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.626 58.0291L232.775 49.1001L227.956 55.0711L224.789 52.5061L235.003 39.8191L239.781 43.6741C242.429 45.8191 243.017 49.1841 241.154 51.5111C240.215 52.6601 238.842 53.3191 237.371 53.3191C236.978 53.3191 236.6 53.2771 236.236 53.1791L236.04 53.1231L235.325 61.0011L231.626 58.0291ZM233.574 48.0621L235.101 49.3241C235.465 49.6321 235.928 49.8011 236.39 49.8011C236.936 49.8011 237.441 49.5621 237.791 49.1281C238.127 48.7071 238.267 48.2021 238.169 47.6841C238.085 47.2071 237.819 46.7731 237.413 46.4501L235.872 45.2021L233.574 48.0621Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.031 40.0579L239.669 43.8149C240.93 44.8379 241.756 46.1839 241.994 47.6139C242.219 49.0019 241.868 50.3469 241.014 51.3989C240.117 52.5059 238.786 53.1509 237.371 53.1509C236.992 53.1509 236.628 53.1089 236.278 53.0109L235.886 52.9129L235.844 53.3189L235.171 60.6649L231.808 57.9449L232.859 49.7169L233.013 48.4829L232.229 49.4499L227.913 54.8049L225.027 52.4639L235.031 40.0579ZM236.404 49.9689C237.007 49.9689 237.553 49.7029 237.945 49.2259C238.309 48.7629 238.464 48.2169 238.366 47.6419C238.267 47.1229 237.987 46.6459 237.553 46.2959L236.152 45.1609L235.872 44.9359L235.647 45.2169L233.56 47.8099L233.336 48.0759L233.602 48.3009L235.003 49.4499C235.409 49.7869 235.9 49.9689 236.404 49.9689ZM234.975 39.5669L224.537 52.5199L227.97 55.2959L232.509 49.6739L231.43 58.0999L235.451 61.3519L236.18 53.3469C236.558 53.4449 236.964 53.4879 237.357 53.4879C238.786 53.4879 240.257 52.8709 241.28 51.6089C243.157 49.2819 242.681 45.7909 239.893 43.5199L234.975 39.5669ZM236.404 49.6179C235.984 49.6179 235.563 49.4639 235.227 49.1839L233.826 48.0339L235.928 45.4409L237.329 46.5759C238.043 47.1649 238.324 48.2029 237.665 49.0019C237.329 49.4219 236.866 49.6179 236.404 49.6179Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.502 62.2631L248.131 50.8101L255.473 58.2541L252.783 60.9031L248.271 56.3191L246.366 58.1981L250.079 61.9691L247.697 64.3101L243.984 60.5391L242.036 62.4591L246.548 67.0441L243.844 69.7211L236.502 62.2631Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.131 51.0481L255.221 58.2541L252.783 60.6511L248.509 56.3191L248.257 56.0671L248.005 56.3191L246.352 57.9451L246.1 58.1981L246.352 58.4501L249.826 61.9691L247.697 64.0711L244.222 60.5531L243.97 60.3001L243.718 60.5391L242.008 62.2211L241.756 62.4731L242.008 62.7261L246.282 67.0571L243.83 69.4831L236.74 62.2771L248.131 51.0481ZM248.131 50.5581L236.25 62.2631L243.83 69.9591L246.786 67.0431L242.275 62.4591L243.984 60.7771L247.697 64.5481L250.331 61.9551L246.618 58.1841L248.271 56.5441L252.783 61.1281L255.711 58.2401L248.131 50.5581Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.944 81.735C254.436 81.735 252.026 80.473 250.331 78.272C247.22 74.207 247.739 68.74 251.55 65.824C253.007 64.702 254.772 64.114 256.636 64.114C259.452 64.114 262.072 65.431 263.851 67.744C265.07 69.37 265.813 71.726 265.701 73.534L261.89 73.632C261.96 72.356 261.567 71.011 260.839 70.057C259.928 68.88 258.485 68.165 256.958 68.165C255.907 68.165 254.912 68.501 254.086 69.132C252.25 70.548 251.382 73.478 253.413 76.127C254.268 77.235 255.333 77.866 256.355 77.866C256.888 77.866 257.378 77.711 257.827 77.389L257.981 77.291L255.655 74.249L257.995 72.455L263.011 78.987C262.618 79.38 262.268 79.688 261.932 79.954C260.419 81.118 258.695 81.735 256.944 81.735Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.636 64.2822C259.396 64.2822 261.974 65.5852 263.711 67.8422C264.874 69.3982 265.603 71.6131 265.533 73.3521L262.072 73.4362C262.1 72.1742 261.694 70.8702 260.979 69.9312C260.04 68.6972 258.541 67.9681 256.958 67.9681C255.865 67.9681 254.842 68.3191 253.974 68.9781C252.04 70.4641 251.242 73.5762 253.273 76.2112C254.156 77.3612 255.277 78.0201 256.369 78.0201C256.93 78.0201 257.462 77.8522 257.939 77.5152L258.233 77.3051L258.009 77.0102L255.893 74.2632L257.953 72.6791L262.772 78.9452C262.436 79.2812 262.128 79.5621 261.82 79.8001C260.335 80.9361 258.653 81.5381 256.93 81.5381C254.478 81.5381 252.11 80.3051 250.457 78.1461C247.403 74.1651 247.921 68.8102 251.634 65.9502C253.077 64.8702 254.8 64.2822 256.636 64.2822ZM256.636 63.9312C254.786 63.9312 252.965 64.5062 251.438 65.6832C247.669 68.5852 246.968 74.1651 250.191 78.3701C251.914 80.6271 254.38 81.9032 256.944 81.9032C258.667 81.9032 260.419 81.3282 262.044 80.0952C262.464 79.7722 262.856 79.4082 263.249 79.0012L258.037 72.2162L255.417 74.2212L257.743 77.2491C257.308 77.5571 256.846 77.6971 256.369 77.6971C255.403 77.6971 254.38 77.0952 253.553 76.0152C251.676 73.5622 252.334 70.7022 254.198 69.2722C255.024 68.6412 255.991 68.3471 256.958 68.3471C258.387 68.3471 259.788 68.9922 260.699 70.1692C261.441 71.1512 261.82 72.5531 261.694 73.8141L265.855 73.7162C266.023 71.8522 265.252 69.3561 263.977 67.6461C262.114 65.1931 259.354 63.9312 256.636 63.9312Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -156,
    y: -967,
    width: 2368,
    height: 2260
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1417.5 -966.742L-155.663 3.95679L638.455 1292.52L2211.62 321.824L1417.5 -966.742Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.581 78.0569L256.699 86.6229L258.839 90.0939L272.721 81.5289L270.581 78.0569Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.506 78.3L272.454 81.468L258.877 89.851L256.93 86.683L270.506 78.3ZM270.618 77.823L256.439 86.571L258.765 90.342L272.944 81.594L270.618 77.823Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.662 100.898C265.659 100.898 263.627 99.4539 262.478 97.2109C261.287 94.8699 261.231 92.2209 262.338 90.7069L265.575 91.7999C265.056 92.8929 265.112 94.3089 265.729 95.5289C266.065 96.1879 266.667 96.8889 267.326 96.8889C267.466 96.8889 267.606 96.8609 267.732 96.7909C268.587 96.3559 268.489 94.5339 268.391 92.6129C268.209 89.7669 268.965 88.0149 270.801 87.0899C271.403 86.7809 272.034 86.627 272.706 86.627C274.654 86.627 276.587 87.9589 277.638 90.0199C278.675 92.0659 278.647 94.3089 277.554 95.6409L274.514 94.5899C274.99 93.6499 274.682 92.3749 274.373 91.7439C274.037 91.0709 273.463 90.6509 272.93 90.6509C272.776 90.6509 272.636 90.6789 272.51 90.7489C271.865 91.0709 271.95 91.9399 272.09 93.2299C272.118 93.5659 272.16 93.9589 272.188 94.3649C272.412 97.4349 271.585 99.4119 269.666 100.393C269.035 100.744 268.349 100.898 267.662 100.898Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.692 86.8239C274.57 86.8239 276.447 88.1129 277.47 90.1179C278.451 92.0529 278.451 94.1549 277.484 95.4449L274.752 94.5059C275.144 93.5379 274.85 92.3329 274.528 91.6879C274.149 90.9589 273.547 90.4959 272.93 90.4959C272.748 90.4959 272.58 90.5389 272.426 90.6229C271.669 91.0009 271.767 91.9119 271.908 93.2859C271.95 93.6229 271.978 94.0009 272.02 94.4219C272.244 97.4219 271.445 99.3279 269.596 100.281C268.979 100.604 268.321 100.758 267.648 100.758C265.715 100.758 263.739 99.3419 262.618 97.1689C261.483 94.9399 261.399 92.4309 262.394 90.9589L265.322 91.9399C264.874 93.0619 264.944 94.4359 265.561 95.6549C265.925 96.3559 266.569 97.1129 267.312 97.1129C267.48 97.1129 267.634 97.0709 267.788 97.0009C268.755 96.5099 268.643 94.6319 268.545 92.6269C268.363 89.8799 269.105 88.1829 270.857 87.2859C271.445 86.9639 272.062 86.8239 272.692 86.8239ZM272.692 86.4729C272.02 86.4729 271.347 86.6269 270.717 86.9499C268.475 88.0849 268.069 90.3279 268.223 92.6269C268.321 94.4079 268.419 96.2719 267.662 96.6649C267.564 96.7209 267.452 96.7349 267.34 96.7349C266.808 96.7349 266.261 96.1599 265.897 95.4589C265.266 94.2109 265.238 92.7809 265.827 91.7019L262.282 90.5099C261.021 92.0949 261.077 94.8559 262.324 97.2949C263.473 99.5379 265.519 101.08 267.662 101.08C268.363 101.08 269.063 100.912 269.764 100.562C271.95 99.4399 272.58 97.1829 272.384 94.3659C272.244 92.4169 271.922 91.2669 272.608 90.9169C272.72 90.8609 272.832 90.8329 272.958 90.8329C273.407 90.8329 273.911 91.1969 274.247 91.8279C274.612 92.5429 274.85 93.8469 274.289 94.6879L277.638 95.8519C278.801 94.5199 278.969 92.2209 277.82 89.9499C276.713 87.8469 274.71 86.4729 272.692 86.4729Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.284 107.192L278.969 102.692L277.54 98.9629L281.071 97.6179L285.386 108.875L281.855 110.234L280.426 106.505L268.755 110.991L267.284 107.192Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.973 97.8419L285.176 108.776L281.967 110.01L280.664 106.618L280.538 106.295L280.216 106.421L268.867 110.781L267.536 107.305L278.885 102.945L279.207 102.819L279.081 102.496L277.778 99.0899L280.973 97.8419ZM281.169 97.3789L277.316 98.8649L278.745 102.594L267.06 107.08L268.643 111.216L280.328 106.73L281.757 110.459L285.61 108.973L281.169 97.3789Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273 125.052L279.249 118.533L271.824 120.468L270.801 116.515L286.577 112.393L288.118 118.351C288.538 119.977 288.398 121.589 287.712 122.921C287.039 124.211 285.918 125.122 284.559 125.473C284.153 125.585 283.733 125.627 283.326 125.627C281.883 125.627 280.482 124.982 279.6 123.888L279.473 123.734L274.205 129.65L273 125.052ZM280.51 118.183L281.001 120.103C281.225 120.987 281.967 121.617 282.808 121.617C282.962 121.617 283.13 121.589 283.284 121.561C283.803 121.421 284.209 121.099 284.447 120.622C284.657 120.188 284.714 119.669 284.587 119.178L284.083 117.258L280.51 118.183Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.451 112.604L287.951 118.393C288.357 119.977 288.217 121.547 287.559 122.837C286.914 124.085 285.834 124.968 284.517 125.304C284.125 125.403 283.719 125.459 283.326 125.459C281.925 125.459 280.594 124.828 279.74 123.776L279.487 123.454L279.207 123.762L274.289 129.286L273.197 125.094L278.941 119.094L279.796 118.197L278.605 118.505L271.936 120.244L270.997 116.641L286.451 112.604ZM282.822 121.786C282.99 121.786 283.172 121.758 283.34 121.716C283.901 121.576 284.363 121.211 284.615 120.692C284.854 120.216 284.896 119.669 284.755 119.122L284.307 117.37L284.223 117.034L283.887 117.118L280.65 117.959L280.314 118.043L280.398 118.379L280.846 120.132C281.071 121.113 281.883 121.786 282.822 121.786ZM286.689 112.183L270.562 116.403L271.669 120.692L278.675 118.87L272.79 125.01L274.093 130.029L279.445 124.015C280.342 125.108 281.758 125.823 283.312 125.823C283.734 125.823 284.167 125.767 284.587 125.655C287.474 124.898 289.183 121.8 288.272 118.323L286.689 112.183ZM282.822 121.435C282.023 121.435 281.366 120.833 281.184 120.062L280.734 118.309L283.971 117.468L284.434 119.22C284.672 120.118 284.265 121.127 283.27 121.379C283.102 121.421 282.962 121.435 282.822 121.435Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.318 136.337L275.284 137.374L274.682 133.365L281.631 132.328L290.066 125.977L290.752 130.533L286.114 133.701L291.481 135.342L292.167 139.926L282.318 136.337Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.94 126.286L290.57 130.449L286.325 133.351L285.722 133.757L286.423 133.968L291.327 135.482L291.957 139.645L282.374 136.169L282.29 136.141L282.206 136.155L275.438 137.178L274.892 133.519L281.659 132.496L281.743 132.482L281.813 132.426L289.94 126.286ZM290.206 125.655L281.603 132.145L274.486 133.211L275.144 137.557L282.262 136.491L292.391 140.178L291.635 135.201L286.521 133.631L290.948 130.617L290.206 125.655Z",
    fill: "#001973"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.462 33.385C85.9417 33.385 33.457 85.898 33.457 150.454C33.457 214.995 85.9417 267.494 150.462 267.494C214.968 267.494 267.438 214.995 267.438 150.454C267.452 85.898 214.968 33.385 150.462 33.385Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.99 167.57L290.009 168.495L263.431 195.481L278.044 174.608L269.862 173.556L295.768 148.645L282.99 167.57Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9806 167.977L9.9752 168.888L36.5537 195.887L21.9405 175.014L30.1228 173.962L4.2168 149.038L16.9806 167.977Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5293 61.955H211.647C194.302 49.969 173.257 42.946 150.588 42.946C127.904 42.946 106.874 49.969 89.5293 61.955Z",
    fill: "#BE1E2D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9936 81.595C62.9636 87.623 58.5645 94.197 54.9355 101.235H246.226C242.583 94.197 238.197 87.623 233.168 81.595H67.9936Z",
    fill: "#BE1E2D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1322 120.875C45.3248 127.197 44.0778 133.772 43.4473 140.514H257.715C257.084 133.772 255.837 127.197 254.03 120.875H47.1322Z",
    fill: "#BE1E2D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3906 160.168C43.979 166.911 45.1839 173.486 46.9633 179.808H254.184C255.963 173.472 257.168 166.911 257.757 160.168H43.3906Z",
    fill: "#BE1E2D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6562 199.448C58.2292 206.472 62.5582 213.06 67.5322 219.088H233.644C238.618 213.06 242.947 206.472 246.52 199.448H54.6562Z",
    fill: "#BE1E2D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.446 238.728H88.7305C106.23 251.051 127.568 258.284 150.588 258.284C173.608 258.284 194.946 251.051 212.446 238.728Z",
    fill: "#BE1E2D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.218 42.9601C151.008 42.9601 150.798 42.946 150.574 42.946C94.5437 42.946 48.5325 85.7861 43.4326 140.514H151.204V42.9601H151.218Z",
    fill: "#152656"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2867 112.702L85.5207 107.262L83.7697 112.702H78.0537L82.6767 116.052L80.9117 121.491L85.5207 118.127L90.1447 121.491L88.3797 116.052L93.0027 112.702H87.2867Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.093 112.996L122.328 107.557L120.577 112.996H114.86L119.484 116.361L117.718 121.786L122.328 118.435L126.951 121.786L125.186 116.361L129.81 112.996H124.093Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.453 99.426L139.687 94.001L137.922 99.426H132.219L136.843 102.791L135.078 108.216L139.687 104.865L144.311 108.216L142.545 102.791L147.169 99.426H141.453Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.44 99.7209L104.674 94.2949L102.909 99.7209H97.207L101.816 103.085L100.051 108.524L104.674 105.16L109.298 108.524L107.533 103.085L112.156 99.7209H106.44Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3668 93.9871L67.6018 99.4261H61.8848L66.5088 102.79L64.7428 108.216L69.3668 104.865L73.9768 108.216L72.2248 102.79L76.8348 99.4261H71.1318L69.3668 93.9871Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8893 85.674L86.1242 80.249L84.3592 85.674H78.6562L83.2663 89.038L81.5002 94.478L86.1242 91.113L90.7482 94.478L88.9822 89.038L93.6062 85.674H87.8893Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.561 83.8519L122.188 78.4399L120.422 83.8799H114.706L119.33 87.2299L117.564 92.6689L122.188 89.3049L126.811 92.6689L125.046 87.2299L129.656 83.8799L123.561 83.8519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.453 72.2019L139.687 66.7629L137.922 72.2019H132.219L136.843 75.5669L135.078 80.9919L139.687 77.6409L144.311 80.9919L142.545 75.5669L147.169 72.2019H141.453Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.44 71.2491L104.674 65.8101L102.909 71.2491H97.207L101.816 74.5991L100.051 80.0391L104.674 76.6741L109.298 80.0391L107.533 74.5991L112.156 71.2491H106.44Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.093 57.5671L122.328 52.1421L120.577 57.5671H114.86L119.484 60.9311L117.718 66.3701L122.328 63.0061L126.951 66.3701L125.186 60.9311L129.81 57.5671H124.093Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3668 121.8L67.6018 127.239H61.8848L66.5088 130.589L64.7428 136.029L69.3668 132.664L73.9768 136.029L72.2248 130.589L76.8348 127.239H71.1318L69.3668 121.8Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.44 127.674L104.674 122.234L102.909 127.674H97.207L101.816 131.024L100.051 136.463L104.674 133.099L109.298 136.463L107.533 131.024L112.156 127.674H106.44Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.453 127.674L139.687 122.234L137.922 127.674H132.219L136.843 131.024L135.078 136.463L139.687 133.099L144.311 136.463L142.545 131.024L147.169 127.674H141.453Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9475 251.471L56.6865 252.733L51.8535 247.882L59.8815 239.864L61.1425 241.125L54.3745 247.896L57.9475 251.471Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -351,
    y: -1339,
    width: 2364,
    height: 2387
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M894.716 -1339L-350.252 27.395L768.01 1047.41L2012.98 -318.986L894.716 -1339Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5647 245.485L57.9287 253.866L59.2437 255.065L66.8797 246.684L65.5647 245.485Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.281 252.074C62.25 254.555 62.642 258.284 65.136 260.317C66.439 261.396 67.882 261.606 69.241 261.48L69.353 259.714C68.26 259.812 67.125 259.63 66.215 258.901C64.645 257.611 64.225 254.989 65.668 253.209C67.111 251.457 69.759 251.303 71.357 252.606C72.211 253.307 72.688 254.373 72.8 255.494L74.481 255.06C74.313 253.518 73.654 252.172 72.533 251.219C70.068 249.214 66.313 249.592 64.281 252.074Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.7871 263.709L75.3081 267.578L76.3161 266.12L72.2531 263.275L74.0471 260.709L77.5631 263.162L78.5721 261.719L75.0691 259.251L76.7231 256.882L80.8001 259.728L81.7951 258.298L76.2741 254.429L69.7871 263.709Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5782 269.261L83.2522 259.041L83.1822 258.999L77.2412 268.91L78.7682 269.835L82.5652 263.485L84.8912 273.718L84.9752 273.761L90.9162 263.835L89.3752 262.91L85.5782 269.261Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0837 267.242C90.2847 268.826 91.3077 270.116 92.2327 271.223C93.1567 272.317 94.2077 273.55 93.7457 274.489C93.3677 275.26 92.2327 275.387 91.0837 274.812C90.1167 274.321 89.4867 273.452 89.4307 272.443L87.7207 272.709C87.7207 274.167 88.5897 275.583 90.2567 276.41C92.3167 277.433 94.4457 277.055 95.3427 275.246C96.1417 273.648 95.2867 272.26 94.0257 270.746C93.0587 269.611 92.2607 268.854 92.6527 268.069C93.0027 267.354 94.0397 267.144 94.9647 267.606C95.7067 267.971 96.2117 268.7 96.1837 269.541L97.7807 269.317C97.9207 267.999 97.1927 266.765 95.7347 266.036C93.9137 265.139 91.9097 265.574 91.0837 267.242Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.792 278.849L102.026 281.443L102.699 279.816L98.117 277.896L99.322 275.008L103.287 276.648L103.974 275.022L100.009 273.368L101.13 270.69L105.711 272.597L106.384 270.985L100.163 268.391L95.792 278.849Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.769 272.541L107.715 271.531L104.142 282.27L107.196 283.293C110.601 284.429 113.417 283.083 114.51 279.788C115.617 276.438 114.174 273.676 110.769 272.541ZM112.801 279.186C112.044 281.457 110.096 282.382 107.757 281.597L106.37 281.134L108.835 273.746L110.209 274.209C112.562 274.994 113.571 276.915 112.801 279.186Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -389,
    y: -1456,
    width: 1862,
    height: 2122
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.52158 -1455.67L-388.043 353.744L1093.14 665.084L1472.66 -1144.33L-8.52158 -1455.67Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.868 276.422L122.539 287.521L124.281 287.887L126.61 276.788L124.868 276.422Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.502 278.555L135.778 290.036L135.68 290.022L129.628 281.429L128.521 288.76L126.755 288.494L128.479 277.027L128.577 277.041L134.629 285.62L135.722 278.303L137.502 278.555Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.908 288.045L139.393 287.148C139.827 288.073 140.738 288.648 141.817 288.732C143.092 288.831 144.087 288.284 144.157 287.429C144.241 286.391 142.798 285.634 141.523 284.975C140.234 284.288 138.819 283.489 138.959 281.709C139.099 279.859 140.808 278.681 142.84 278.835C144.451 278.961 145.6 279.831 145.978 281.106L144.591 281.919C144.297 281.12 143.554 280.644 142.728 280.574C141.691 280.489 140.808 281.078 140.752 281.877C140.682 282.76 141.705 283.153 143.036 283.854C144.773 284.779 146.09 285.746 145.964 287.527C145.81 289.531 143.975 290.695 141.677 290.527C139.799 290.373 138.454 289.405 137.908 288.045Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.59 286.377L147.562 279.326L149.355 279.312L149.383 286.363C149.383 287.933 150.504 289.083 151.891 289.069C153.278 289.055 154.399 287.905 154.385 286.335L154.357 279.284L156.15 279.27L156.178 286.335C156.192 288.943 154.315 290.863 151.905 290.863C149.495 290.891 147.604 288.985 147.59 286.377Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.949 290.036L161.558 285.901L160.171 286.013L160.522 290.387L158.756 290.527L157.845 279.214L161.362 278.933C163.464 278.765 165.313 280.251 165.481 282.256C165.607 283.714 164.767 285.059 163.492 285.592L167.149 289.854L164.949 290.036ZM161.825 284.415C162.889 284.331 163.716 283.405 163.632 282.396C163.548 281.345 162.581 280.644 161.53 280.728L159.751 280.868L160.045 284.569L161.825 284.415Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.082 279.886L169.516 282.76L173.748 282.129L174.014 283.882L169.783 284.513L170.245 287.625L175.163 286.882L175.429 288.634L168.746 289.643L167.064 278.429L173.734 277.419L174 279.157L169.082 279.886Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.251 280.714C186.021 284.106 184.326 286.713 180.823 287.513L177.685 288.228L175.177 277.195L178.315 276.48C181.804 275.681 184.466 277.307 185.251 280.714ZM183.499 281.106C182.967 278.765 181.117 277.644 178.693 278.19L177.278 278.513L179.002 286.111L180.431 285.788C182.841 285.242 184.018 283.433 183.499 281.106Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.57 271.756L196.725 272.835L200.144 281.779L198.463 282.424L195.058 273.466L192.214 274.559L191.583 272.905L198.925 270.102L199.57 271.756Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.302 277.503L205.734 274.756L204.473 275.33L206.267 279.326L204.642 280.055L199.99 269.737L203.198 268.293C205.118 267.438 207.36 268.195 208.186 270.045C208.789 271.377 208.453 272.919 207.43 273.844L212.291 276.62L210.302 277.503ZM205.482 273.256C206.463 272.821 206.911 271.672 206.505 270.746C206.071 269.779 204.922 269.443 203.969 269.877L202.344 270.606L203.857 273.985L205.482 273.256Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.241 272.331L207.892 266.134L209.461 265.279L212.81 271.475C213.552 272.863 215.066 273.34 216.299 272.681C217.518 272.022 217.952 270.48 217.209 269.092L213.861 262.896L215.444 262.041L218.793 268.237C220.025 270.536 219.283 273.102 217.167 274.251C215.038 275.415 212.474 274.63 211.241 272.331Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.328 269.443L221.973 267.845C222.87 268.307 223.935 268.237 224.859 267.648C225.924 266.961 226.414 265.924 225.938 265.195C225.378 264.312 223.78 264.592 222.365 264.817C220.936 265.041 219.311 265.251 218.358 263.751C217.363 262.181 218.008 260.232 219.731 259.125C221.09 258.256 222.533 258.256 223.598 259.055L222.982 260.541C222.267 260.078 221.385 260.148 220.698 260.583C219.829 261.144 219.479 262.139 219.899 262.812C220.376 263.555 221.427 263.26 222.912 263.008C224.845 262.7 226.484 262.686 227.451 264.186C228.53 265.882 227.773 267.901 225.826 269.148C224.243 270.158 222.575 270.186 221.328 269.443Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.8 253.756L228.348 255.55L234.022 263.261L232.593 264.326L226.919 256.616L224.467 258.41L223.43 256.994L229.749 252.326L230.8 253.756Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -205,
    width: 1848,
    height: 1514
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -205H-51V1309H1797V-205Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.028 251.864L234.905 254.078L238.184 251.317L239.318 252.677L236.04 255.438L238.071 257.835L241.868 254.625L243.003 255.985L237.847 260.331L230.548 251.667L235.704 247.322L236.824 248.653L233.028 251.864Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_516_13702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -190,
    width: 1848,
    height: 1514
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1797 -190H-51V1324H1797V-190Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_516_13702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.291 244.041C249.728 246.537 249.63 249.663 247.052 252.172L244.741 254.429L236.824 246.312L239.136 244.055C241.714 241.532 244.839 241.532 247.291 244.041ZM246.002 245.303C244.32 243.579 242.149 243.593 240.369 245.331L239.332 246.34L244.783 251.92L245.833 250.896C247.599 249.172 247.669 247.013 246.002 245.303Z",
    fill: "white"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.818 278.569L190.659 279.648L191.948 279.172L191.177 280.307L192.018 281.387L190.701 281.022L189.944 282.158L189.888 280.784L188.571 280.405L189.86 279.929L189.818 278.569Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M150.463 264.046C87.8475 264.046 36.9043 213.074 36.9043 150.425C36.9043 87.7769 87.8475 36.8049 150.463 36.8049C213.076 36.8049 264.02 87.7769 264.02 150.425C264.006 213.088 213.076 264.046 150.463 264.046ZM150.463 39.9459C89.5705 39.9459 40.0287 89.5149 40.0287 150.44C40.0287 211.364 89.5705 260.933 150.463 260.933C211.354 260.933 260.895 211.364 260.895 150.44C260.881 89.5149 211.354 39.9459 150.463 39.9459Z",
    fill: "#BE1E2D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_516_13702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301,
    height: 301,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a623902868af5546d887161cab85acd1.svg";
export { ForwardRef as ReactComponent };